/**
 * Shared constants for the ops UI.
 */
export const PROJECT_STATUS = {
  new: { label: 'جديد', color: 'bg-[#DBE6F6] text-[#294B7B]' },
  routing: { label: 'قيد التوجيه', color: 'bg-[#FDF3D6] text-[#8A6A18]' },
  discovery: { label: 'استكشاف', color: 'bg-[#F2E3D0] text-[#7A5A2B]' },
  proposal: { label: 'عرض سعر', color: 'bg-[#E9DFF3] text-[#573F7A]' },
  active: { label: 'نشط', color: 'bg-[#DEE7CB] text-[#3F5021]' },
  review: { label: 'مراجعة', color: 'bg-[#D6EAE8] text-[#265855]' },
  pending_approval: { label: 'بانتظار الاعتماد', color: 'bg-[#E9DFF3] text-[#573F7A]' },
  delivered: { label: 'مُسلَّم', color: 'bg-[#C6DFCF] text-[#1F3D2B]' },
  closed: { label: 'مُغلق', color: 'bg-[#D1D1CB] text-[#4A4A45]' },
  overdue: { label: 'متأخر', color: 'bg-[#F0D0C9] text-[#7A2E22]' },
  cancelled: { label: 'مُلغى', color: 'bg-[#F0E3E1] text-[#7A4B44]' },
};

export const TASK_STATUS = {
  todo: { label: 'للتنفيذ', color: 'bg-[#DBE6F6] text-[#294B7B]' },
  in_progress: { label: 'قيد التنفيذ', color: 'bg-[#DEE7CB] text-[#3F5021]' },
  review: { label: 'مراجعة', color: 'bg-[#D6EAE8] text-[#265855]' },
  done: { label: 'مكتملة', color: 'bg-[#C6DFCF] text-[#1F3D2B]' },
  blocked: { label: 'معلَّقة', color: 'bg-[#F0D0C9] text-[#7A2E22]' },
};

export const TASK_STATUS_ORDER = ['todo', 'in_progress', 'review', 'done', 'blocked'];
export const PROJECT_STATUS_ORDER = [
  'active',
  'review',
  'discovery',
  'proposal',
  'pending_approval',
  'delivered',
  'closed',
  'cancelled',
];

/** Format an ISO date to a short Arabic date string. */
export function fmtDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('ar-SA', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return '—';
  }
}
